module.exports = __webpack_public_path__ + "img/food4.27e76094.jpg";